import { EnterpriseReports_DateRangeType, EnterpriseReports_Schedule } from '__generated__/graphql-types';

import type { Report } from 'bundles/enterprise-admin-analytics/types';

import _t from 'i18n!nls/enterprise-admin-analytics';

export const getActivityReport = (): Report => ({
  id: 'content-activity',
  scheduledId: 'scheduled-content-activity',
  name: _t('Content activity'),
  description: _t(
    'Shows activity for every course, specialization or video clip a learner engages with (overall progress, course grade, and estimated learning hours)'
  ),
  scheduled: false,
  export: true,
});

export const getProgramUsageReport = (): Report => ({
  id: 'program-usage',
  scheduledId: 'scheduled-program-usage',
  name: _t('Learner program status'),
  description: _t(
    'Shows a learner’s status in a learning program. You’ll see details like when they joined and how many courses they’ve completed since starting with Coursera.'
  ),
  scheduled: false,
  export: true,
});

export const getMonthlyDigestReport = (): Report => ({
  id: 'monthly-digest',
  name: _t('Monthly digest'),
  description: _t(
    'Regular updates on your organization’s learners and their engagement on Coursera (Ex: shows learning hours, course completion details, trending skills etc)'
  ),
  scheduled: true,
  export: false,
});

export const getReports = (): Report[] => [getActivityReport(), getProgramUsageReport(), getMonthlyDigestReport()];

export const getDefaultContentActivitySchedule = (thirdPartyOrganizationId: string, programIds: string[]) => {
  return {
    dateRange: {
      type: EnterpriseReports_DateRangeType.Last_30Days,
    },
    includeEnrolledWithoutActivity: false,
    includeRemovedMembers: false,
    schedule: EnterpriseReports_Schedule.Monday,
    scope: {
      thirdPartyOrganizationId,
      programIds,
    },
  };
};

export const getDefaultProgramUsageSchedule = (thirdPartyOrganizationId: string, programIds: string[]) => {
  return {
    includeInvitedLearners: false,
    includeRemovedMembers: false,
    includeJoinedLearners: true,
    schedule: EnterpriseReports_Schedule.Monday,
    scope: {
      thirdPartyOrganizationId,
      programIds,
    },
  };
};
